<template>
	<div class="org-management-container">
		<div class="org-management-content" v-if="!loading">
			<Sidebar />
			<div class="org-management">
				<RouterView v-slot="{ Component }">
					<KeepAlive include="People,Groups,Categories" :max="10">
						<component :is="Component" />
					</KeepAlive>
				</RouterView>
			</div>
		</div>
		<CloudLoader class="cloud" animate v-if="loading" />
	</div>
</template>

<script>
import Sidebar from './Sidebar'
import { CloudLoader } from '@/components/common'
import { fetchMyUserInfo } from '@/api/user'
import { mainRoute, overviewRoute } from './index'
import { switchGlobalColorScheme } from '@/helpers/colors'
import { colorSchemes } from '@/helpers/constants'

export default {
	name: 'OrgManagement',
	components: { Sidebar, CloudLoader },
	data() {
		return { loading: true }
	},
	async created() {
		// should be in the light scheme until we can provide dark mode support
		switchGlobalColorScheme(colorSchemes.LIGHT)

		try {
			const data = await fetchMyUserInfo(true)
			if (!['admin', 'support'].includes(data.user.role)) {
				return this.$router.replace({ path: '/' })
			}
		} catch (e) {
			console.error(e)
			return this.$router.replace({ path: '/' })
		}
		if (this.$route.name === mainRoute.name) {
			try {
				this.$router.push({ name: overviewRoute.name })
			} catch (e) {}
		}
		this.loading = false
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.org-management-container {
	position: relative;
	display: flex;
	align-items: flex-start;
	width: 100vw;
	height: 100vh;
	.org-management-content {
		width: 100%;
	}
	.org-management {
		width: 100%;
		flex-grow: 1;
		padding-left: 64px;
	}
	.cloud {
		@include absolute-cover;
	}
}
</style>
